import React, { useEffect, useRef, useState } from "react";
import instance from "../instance";
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';

function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  return `${formattedDay}-${formattedMonth}-${year}`;
}

const convertToXLS = (csvData) => {


  const workbook = XLSX.utils.book_new();
  const sheet = XLSX.utils.json_to_sheet(csvData);
  XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
  const xlsData = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
  return new Blob([s2ab(xlsData)], { type: 'application/octet-stream' });
};

const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i += 1) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
};





const Admin = () => {

    const [allRs,setAllRs] = useState([])
    const [isLoggedIn,setIsLoggedIn] = useState(!!localStorage.getItem('token'))
    const hasMounted = useRef(false)


    const loadReservations = async ()=> {

        try {

            const response = await instance.get("/allUsers" ,{
                headers: {
                  "Content-Type": "application/json",
                  "Authorization":"Bearer "+localStorage.getItem('token')
                }
              })
            setAllRs(response.data)

        } catch (error) {
            console.log(error);
            
        }
    }

    const login = async ()=>{
        
            if(!hasMounted.current) {
                const password = prompt("Veuillez Rentrez Le Mot De Passe")
        
                if(!password) {
                  return
                }
            
                // Send login request to server
                instance.post("/login", 
                  {
                    username:"admin",
                    password
                  }
                ).then(response => {
                  if (response.status === 200) {
                    
                    // After successful authentication
                    
                    
                    localStorage.setItem("token", response.data.token);
                    setIsLoggedIn(true)
            
                    // window.location.href = "/";
            
                  } else {
                    
                    console.log("Y'a une couille là");
                    
                  }
                }).catch(err=>{
                  alert("Mot De Passe Incorrect")
                  console.log(err)
                });
                hasMounted.current= true
            }
            
    }

    useEffect(()=>{
       
            if(!isLoggedIn) login()
            else loadReservations()

        
   
    },[isLoggedIn])

  return  <div className='admin' style={{color:"white"}}>
    <div className="dowload"  style={{width:"280px",height:"40px", background:"white" , borderRadius:"5px", color:"black", margin:"1.5rem",padding:"1rem",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
    <CSVLink
      data={allRs}
      onClick={(event) => {
        event.preventDefault();
        const xlsData = convertToXLS(allRs);
        const url = window.URL.createObjectURL(xlsData);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'reservations.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
       
      }}
     
    >
      Telecharger sous format excel
    </CSVLink>
    </div>


  {/* <h1 className="text-logo"> ADMIN PAGE</h1> */}
  <div className="container">
      <div className="row">
          <h1><strong>Liste des Reservations   </strong></h1>
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Prenom et Nom</th>
                <th>Numero De Telephone</th>
               
                <th>Email</th>
                <th>Adresse</th>
                <th>Pièce d'identité</th>
                <th>Nombre mètres</th>

                <th>Date de la reservations</th>
                <th>Payé</th>
              </tr>
            </thead>
            <tbody>
                {allRs.length >0 && allRs.map((rs,index)=>{
                    return (
                        <tr key={index}>
                            <td>{rs.fullName} </td>
                            <td>{rs.phone} </td>
                            
                            <td>{rs.email} </td>
                            <td>{rs.address} </td>
                            <td> <a href={rs.fileLink} target="_blank">Lien</a> </td>
                            <td>{rs.meter} </td>
                            <td> {formatDate(new Date(rs.createdAt))} </td>
                            <td> {rs.paymentId ? "Oui" : "Non"} </td>
                        </tr>
                    )
                })}
             
            </tbody>
          </table>
      </div>
     
  </div>
  </div>;
};

export default Admin;
